<div class=" d-none d-sm-block">
  <!------------------------------------------ HEADER IMAGE --------------------------------------->
 <!------------------------------------------TITLE----------------------------------------------->
 <div class="title-box uk-border-rounded p-1 d-none d-sm-block">
  <div class="head-card p-1 inner-title-box">
    <h1 class="title-text text-center font-weight-bold">
      Gallery
    </h1>
    <div class="text-right">
      <h5 class="text-light">
        <span class="sub-menu" routerLink="/home-page">Home </span>&nbsp;/&nbsp;
        <!-- <span class="sub-menu sub-menu-text font-weight-bold">Custom Software Development</span>&nbsp;/&nbsp; -->
        <span class="sub-menu" routerLink="/contact-us"> Contact Us</span>
      </h5>
    </div>
  </div>
 </div>
<!--------------------------------------------------TITLE END-------------------------------------------->
<!------------------------------------------ END ------------------------------------------------->

<!------------------------------------------ WEBSITES---------------------------------------------->
<div class="bg-light">
  <div class="container-fluid">
    <!-- Page Title -->
    <h4 class="font-weight-bolder align-middle text-center text-uppercase d-block d-sm-none">
      Gallery
    </h4>

    <!-- Gallery Row 1 -->
    <div class="row p-4 animatable bounceInLeft">
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/1.jpg" class="image" alt="Dhandayuthapani Temple">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/2.jpg" class="image" alt="Subramanya Swami-Thiruttani">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/3.jpg" class="image" alt="Gowmariyamman Temple">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/4.jpg" class="image" alt="Sri Vanchinathar Temple">
        </div>
      </div>
    </div>

    <!-- Gallery Row 2 -->
    <div class="row p-4 animatable bounceInRight">
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/5.jpg" class="image" alt="Sarangapani Swamy Temple">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/6.jpg" class="image" alt="Villagers Construction">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/7.jpg" class="image" alt="Samayapuram Maariamman">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/8.jpg" class="image" alt="Seshapureeswarar Temple">
        </div>
      </div>
    </div>

    <!-- Gallery Row 3 -->
    <div class="row p-4 animatable bounceIn">
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/9.jpg" class="image" alt="Vallalar Temple">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/10.jpg" class="image" alt="Kumbakonam Home Stay">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/11.jpg" class="image" alt="Anjaneyar Swamy Temple">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/12.jpg" class="image" alt="Subramaniya Swamy-Ettukudi">
        </div>
      </div>
    </div>
    <div class="row p-4 animatable bounceIn">
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/13.jpg" class="image" alt="Vallalar Temple">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/14.jpg" class="image" alt="Kumbakonam Home Stay">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/15.jpg" class="image" alt="Anjaneyar Swamy Temple">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/16.jpg" class="image" alt="Subramaniya Swamy-Ettukudi">
        </div>
      </div>
    </div>
    <div class="row p-4 animatable bounceIn">
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/17.jpg" class="image" alt="Vallalar Temple">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/18.jpg" class="image" alt="Kumbakonam Home Stay">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/19.jpg" class="image" alt="Anjaneyar Swamy Temple">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/20.jpg" class="image" alt="Subramaniya Swamy-Ettukudi">
        </div>
      </div>
    </div>
    <div class="row p-4 animatable bounceIn">
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/21.jpg" class="image" alt="Vallalar Temple">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/22.jpg" class="image" alt="Kumbakonam Home Stay">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/23.jpg" class="image" alt="Anjaneyar Swamy Temple">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/24.jpg" class="image" alt="Subramaniya Swamy-Ettukudi">
        </div>
      </div>
    </div>
    <div class="row p-4 animatable bounceIn">
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/25.jpg" class="image" alt="Vallalar Temple">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/26.jpg" class="image" alt="Kumbakonam Home Stay">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/27.jpg" class="image" alt="Anjaneyar Swamy Temple">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/28.jpg" class="image" alt="Subramaniya Swamy-Ettukudi">
        </div>
      </div>
    </div>
    <div class="row p-4 animatable bounceIn">
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/29.jpg" class="image" alt="Vallalar Temple">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/30.jpg" class="image" alt="Kumbakonam Home Stay">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/31.jpg" class="image" alt="Anjaneyar Swamy Temple">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/32.jpg" class="image" alt="Subramaniya Swamy-Ettukudi">
        </div>
      </div>
    </div>
    <div class="row p-4 animatable bounceIn">
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/33.jpg" class="image" alt="Vallalar Temple">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/34.jpg" class="image" alt="Kumbakonam Home Stay">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/35.jpg" class="image" alt="Anjaneyar Swamy Temple">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/36.jpg" class="image" alt="Subramaniya Swamy-Ettukudi">
        </div>
      </div>
    </div>
    <div class="row p-4 animatable bounceIn">
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/37.jpg" class="image" alt="Vallalar Temple">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/38.jpg" class="image" alt="Kumbakonam Home Stay">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/39.jpg" class="image" alt="Anjaneyar Swamy Temple">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/p1.jpg" class="image" alt="Subramaniya Swamy-Ettukudi">
        </div>
      </div>
    </div>
    <div class="row p-4 animatable bounceIn">
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/p2.jpg" class="image" alt="Vallalar Temple">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/p4.jpg" class="image" alt="Kumbakonam Home Stay">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/p5.jpg" class="image" alt="Anjaneyar Swamy Temple">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/p6.jpg" class="image" alt="Subramaniya Swamy-Ettukudi">
        </div>
      </div>
    </div>
    <div class="row p-4 animatable bounceIn">
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/p7.jpg" class="image" alt="Vallalar Temple">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/p8.jpg" class="image" alt="Kumbakonam Home Stay">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/p9.jpg" class="image" alt="Anjaneyar Swamy Temple">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/p10.jpg" class="image" alt="Subramaniya Swamy-Ettukudi">
        </div>
      </div>
    </div>
    <div class="row p-4 animatable bounceIn">
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/p11.jpg" class="image" alt="Vallalar Temple">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/p12.jpg" class="image" alt="Kumbakonam Home Stay">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/p13.jpg" class="image" alt="Anjaneyar Swamy Temple">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/p14.jpg" class="image" alt="Subramaniya Swamy-Ettukudi">
        </div>
      </div>
    </div>
    <div class="row p-4 animatable bounceIn">
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/p15.jpg" class="image" alt="Vallalar Temple">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/p16.jpg" class="image" alt="Kumbakonam Home Stay">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/p17.jpg" class="image" alt="Anjaneyar Swamy Temple">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/24.jpg" class="image" alt="Subramaniya Swamy-Ettukudi">
        </div>
      </div>
    </div>
  </div>
</div>
</div>
<!--------------------------------------- MOBILE VIEW ------------------------------------------------->

<div class=" d-block d-sm-none">
  <!------------------------------------------ HEADER IMAGE --------------------------------------->
 <!------------------------------------------TITLE----------------------------------------------->
 
<div class="bg-light">
  <div class="container-fluid">
    <!-- Page Title -->
    <h4 class="font-weight-bolder align-middle text-center text-uppercase d-block d-sm-none">
      Gallery
    </h4>

    <!-- Gallery Row 1 -->
    <div class="row p-4  bounceInLeft">
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/1.jpg" class="image" alt="Dhandayuthapani Temple">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/2.jpg" class="image" alt="Subramanya Swami-Thiruttani">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/3.jpg" class="image" alt="Gowmariyamman Temple">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/4.jpg" class="image" alt="Sri Vanchinathar Temple">
        </div>
      </div>
    </div>

    <!-- Gallery Row 2 -->
    <div class="row p-4  bounceInRight">
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/5.jpg" class="image" alt="Sarangapani Swamy Temple">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/6.jpg" class="image" alt="Villagers Construction">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/7.jpg" class="image" alt="Samayapuram Maariamman">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/8.jpg" class="image" alt="Seshapureeswarar Temple">
        </div>
      </div>
    </div>

    <!-- Gallery Row 3 -->
    <div class="row p-4  bounceIn">
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/9.jpg" class="image" alt="Vallalar Temple">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/10.jpg" class="image" alt="Kumbakonam Home Stay">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/11.jpg" class="image" alt="Anjaneyar Swamy Temple">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/12.jpg" class="image" alt="Subramaniya Swamy-Ettukudi">
        </div>
      </div>
    </div>
    <div class="row p-4  bounceIn">
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/13.jpg" class="image" alt="Vallalar Temple">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/14.jpg" class="image" alt="Kumbakonam Home Stay">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/15.jpg" class="image" alt="Anjaneyar Swamy Temple">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/16.jpg" class="image" alt="Subramaniya Swamy-Ettukudi">
        </div>
      </div>
    </div>
    <div class="row p-4  bounceIn">
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/17.jpg" class="image" alt="Vallalar Temple">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/18.jpg" class="image" alt="Kumbakonam Home Stay">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/19.jpg" class="image" alt="Anjaneyar Swamy Temple">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/20.jpg" class="image" alt="Subramaniya Swamy-Ettukudi">
        </div>
      </div>
    </div>
    <div class="row p-4  bounceIn">
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/21.jpg" class="image" alt="Vallalar Temple">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/22.jpg" class="image" alt="Kumbakonam Home Stay">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/23.jpg" class="image" alt="Anjaneyar Swamy Temple">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/24.jpg" class="image" alt="Subramaniya Swamy-Ettukudi">
        </div>
      </div>
    </div>
    <div class="row p-4  bounceIn">
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/25.jpg" class="image" alt="Vallalar Temple">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/26.jpg" class="image" alt="Kumbakonam Home Stay">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/27.jpg" class="image" alt="Anjaneyar Swamy Temple">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/28.jpg" class="image" alt="Subramaniya Swamy-Ettukudi">
        </div>
      </div>
    </div>
    <div class="row p-4  bounceIn">
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/29.jpg" class="image" alt="Vallalar Temple">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/30.jpg" class="image" alt="Kumbakonam Home Stay">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/31.jpg" class="image" alt="Anjaneyar Swamy Temple">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/32.jpg" class="image" alt="Subramaniya Swamy-Ettukudi">
        </div>
      </div>
    </div>
    <div class="row p-4  bounceIn">
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/33.jpg" class="image" alt="Vallalar Temple">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/34.jpg" class="image" alt="Kumbakonam Home Stay">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/35.jpg" class="image" alt="Anjaneyar Swamy Temple">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/36.jpg" class="image" alt="Subramaniya Swamy-Ettukudi">
        </div>
      </div>
    </div>
    <div class="row p-4 bounceIn">
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/37.jpg" class="image" alt="Vallalar Temple">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/38.jpg" class="image" alt="Kumbakonam Home Stay">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/39.jpg" class="image" alt="Anjaneyar Swamy Temple">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/p1.jpg" class="image" alt="Subramaniya Swamy-Ettukudi">
        </div>
      </div>
    </div>
    <div class="row p-4  bounceIn">
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/p2.jpg" class="image" alt="Vallalar Temple">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/p4.jpg" class="image" alt="Kumbakonam Home Stay">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/p5.jpg" class="image" alt="Anjaneyar Swamy Temple">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/p6.jpg" class="image" alt="Subramaniya Swamy-Ettukudi">
        </div>
      </div>
    </div>
    <div class="row p-4  bounceIn">
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/p7.jpg" class="image" alt="Vallalar Temple">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/p8.jpg" class="image" alt="Kumbakonam Home Stay">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/p9.jpg" class="image" alt="Anjaneyar Swamy Temple">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/p10.jpg" class="image" alt="Subramaniya Swamy-Ettukudi">
        </div>
      </div>
    </div>
    <div class="row p-4  bounceIn">
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/p11.jpg" class="image" alt="Vallalar Temple">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/p12.jpg" class="image" alt="Kumbakonam Home Stay">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/p13.jpg" class="image" alt="Anjaneyar Swamy Temple">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/p14.jpg" class="image" alt="Subramaniya Swamy-Ettukudi">
        </div>
      </div>
    </div>
    <div class="row p-4 bounceIn">
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/p15.jpg" class="image" alt="Vallalar Temple">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/p16.jpg" class="image" alt="Kumbakonam Home Stay">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/p17.jpg" class="image" alt="Anjaneyar Swamy Temple">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12 p-1">
        <div class="box12">
          <img src="./../../assets/img/rv-gallery/24.jpg" class="image" alt="Subramaniya Swamy-Ettukudi">
        </div>
      </div>
    </div>
  </div>
</div>
</div>
